import { render } from "./ForecastingPCO.vue?vue&type=template&id=0a73095d&ts=true"
import script from "./ForecastingPCO.vue?vue&type=script&lang=ts"
export * from "./ForecastingPCO.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__